import React from "react";

const FAQ_ITEMS = [
  {
    question: "Is this only for moms?",
    answer:
      "No. The workbook is for any woman of faith who has gone missing inside her own life: moms, wives, ministry leaders, entrepreneurs, and caregivers alike. The six B's framework meets you wherever your burnout is coming from.",
  },
  {
    question: "How much time does it take?",
    answer:
      "It is fully self-paced. The 64 guided pages are organized into five sections, so you can work through a few pages a day or sit down for longer sessions. Most women move through it over a few weeks alongside real life.",
  },
  {
    question: "What do I receive?",
    answer:
      "You receive the physical From Burnout to Becoming workbook shipped to you, plus instant digital access so you can begin the moment you order.",
  },
  {
    question: "Is it Scripture-rooted?",
    answer:
      "Yes. Every section pairs biblical principles with practical written exercises, so the truth you uncover turns into a plan you can actually walk out.",
  },
  {
    question: "What is included in the $67 bundle?",
    answer:
      "The bundle includes the Identity Reset workshop (the full teaching video with guided reflection) plus the physical workbook with instant digital access, and shipping is included.",
  },
];

export const WorkbookBottomSections = () => {
  return (
    <>
      {/* SECTION 8: You love your life, but you have gone missing inside of it */}
      <section className="bg-[#FAF6F0] py-16 md:py-24 w-full">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-6 space-y-4">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B50] block">
                THIS WORKBOOK IS FOR YOU IF
              </span>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal text-[#380C1E] leading-[1.15]">
                You love your life, but you have gone missing inside of it.
              </h2>
            </div>
            <div className="lg:col-span-6 space-y-3">
              {[
                "Everyone gets the best of you, and you get whatever is left.",
                "You look capable on the outside while quietly running on empty.",
                "You keep moving the dream God gave you to next week, next month, or someday.",
                "You no longer know who you are outside of the roles you carry.",
                "You know something has to change, but you do not know where to start.",
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="bg-[#EFE6D2]/60 rounded-xl p-4 border border-[#E8DEC8] text-xs sm:text-sm text-[#380C1E]/80 font-light"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 9: Burnout does not come from one place (Six Sources) */}
      <section className="bg-[#FBF1F4] py-16 md:py-24 w-full border-y border-[#E8DEC8]">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto space-y-12">
          <div className="max-w-3xl space-y-3">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B50] block">
              YOUR EXHAUSTION HAS A NAME
            </span>
            <h2 className="font-serif text-3xl sm:text-5xl font-normal text-[#380C1E] leading-tight">
              Burnout does not come from one place. It comes from six.
            </h2>
            <p className="text-xs sm:text-sm text-[#380C1E]/70 font-light leading-relaxed">
              Most women are fighting the wrong tired. The workbook helps you
              find what is actually draining you, because the fix for one source
              will not fix another.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                num: "01",
                title: "Beliefs",
                desc: "Change the stuck story.",
              },
              {
                num: "02",
                title: "Belonging",
                desc: "Build a circle that can hold the truth.",
              },
              {
                num: "03",
                title: "Boundaries",
                desc: "Strengthen the no that protects your yes.",
              },
              {
                num: "04",
                title: "Business",
                desc: "Take the dream off the someday shelf.",
              },
              {
                num: "05",
                title: "Budget",
                desc: "Face the numbers without shame.",
              },
              {
                num: "06",
                title: "Body",
                desc: "Build rhythms that truly restore you.",
              },
            ].map((card) => (
              <div
                key={card.num}
                className="bg-white rounded-2xl p-6 border border-[#E8DEC8] space-y-2 relative"
              >
                <span className="text-[10px] text-[#9E1B50] font-mono font-bold absolute top-6 right-6">
                  {card.num}
                </span>
                <h3 className="font-serif text-xl font-bold text-[#380C1E]">
                  {card.title}
                </h3>
                <p className="text-xs text-[#380C1E]/70 font-light">
                  {card.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 10: This is not a book you read. It is a book you answer */}
      <section className="bg-white py-16 md:py-24 w-full border-b border-[#E8DEC8]">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-5 space-y-4">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B50] block">
                INSIDE THE WORKBOOK
              </span>
              <h2 className="font-serif text-3xl sm:text-5xl font-normal text-[#380C1E] leading-[1.15]">
                This is not a book you read. It is a book you answer.
              </h2>
              <p className="text-xs sm:text-sm text-[#380C1E]/70 font-light leading-relaxed">
                Five focused sections move you from honest awareness to a
                written plan you can actually live.
              </p>
            </div>

            <div className="lg:col-span-7 space-y-4">
              {[
                {
                  num: "01",
                  title: "Identity Reset",
                  desc: "Separate who you are from who you became to survive.",
                },
                {
                  num: "02",
                  title: "Vision & Calling",
                  desc: "Hear the dream again and name where God is leading you.",
                },
                {
                  num: "03",
                  title: "Mindset Shift",
                  desc: "Replace inherited and pain-formed beliefs with truth.",
                },
                {
                  num: "04",
                  title: "Purpose Planning",
                  desc: "Turn clarity into practical priorities and next steps.",
                },
                {
                  num: "05",
                  title: "Becoming in Real Life",
                  desc: "Build rhythms that make the new life sustainable.",
                },
              ].map((step) => (
                <div
                  key={step.num}
                  className="bg-[#FAF6F0] rounded-xl p-5 border border-[#E8DEC8] flex items-start gap-4"
                >
                  <span className="text-xs font-mono font-bold text-[#9E1B50] pt-0.5">
                    {step.num}
                  </span>
                  <div>
                    <h3 className="font-serif text-lg font-bold text-[#380C1E]">
                      {step.title}
                    </h3>
                    <p className="text-xs text-[#380C1E]/70 font-light pt-0.5">
                      {step.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 11: What $27 Buys Plainly */}
      <section className="bg-[#380C1E] text-white py-16 md:py-24 w-full">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-white/70 block">
                WHAT $27 BUYS, PLAINLY
              </span>
              <h2 className="font-serif text-3xl sm:text-5xl font-normal text-white leading-[1.15]">
                A plan, not another temporary feeling.
              </h2>
              <p className="text-sm md:text-base text-white/80 font-light leading-relaxed max-w-xl">
                This is six weeks of finding what has actually been draining
                you, with instant digital access while your print edition ships.
                If you later join the Becoming Intensive, every dollar from your
                workbook purchase counts toward that guided experience.
              </p>
            </div>

            <div className="lg:col-span-5">
              <div className="bg-white text-[#380C1E] rounded-3xl p-8 space-y-6 text-center shadow-2xl">
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#9E1B50] block">
                  FROM BURNOUT TO BECOMING
                </span>
                <div className="font-serif text-5xl font-bold text-[#380C1E]">
                  $27
                </div>
                <span className="text-[10px] uppercase font-bold text-[#380C1E]/60 block -mt-4">
                  + ST SHIPPING
                </span>
                <a
                  href="https://store.iamieshiadanielle.com/product-details/product/from-burnout-to-becoming-purpose-workbook-for-moms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-[#9E1B50] hover:bg-[#801440] text-white font-bold uppercase text-[11px] tracking-wider py-4 rounded-xl block transition-all"
                >
                  ORDER MY WORKBOOK
                </a>
                <p className="text-[10px] text-[#380C1E]/60 font-light leading-tight">
                  64 guided pages · physical + instant digital access · Licensed
                  for personal use only
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 12: FAQ Accordion / Details */}
      <section className="bg-[#FAF6F0] py-16 md:py-24 w-full border-b border-[#E8DEC8]">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-4 space-y-2">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B50] block">
                BEFORE YOU ASK
              </span>
              <h2 className="font-serif text-3xl sm:text-5xl font-normal text-[#380C1E]">
                The details.
              </h2>
            </div>

            <div className="lg:col-span-8 space-y-3">
              {FAQ_ITEMS.map((item, idx) => (
                <details
                  key={idx}
                  className="bg-white rounded-xl border border-[#E8DEC8] p-4 group cursor-pointer"
                >
                  <summary className="font-serif text-base font-bold text-[#380C1E] list-none flex items-center justify-between">
                    <span>▶ {item.question}</span>
                  </summary>
                  <p className="text-xs sm:text-sm text-[#380C1E]/80 font-light pt-3 leading-relaxed border-t border-[#E8DEC8] mt-3">
                    {item.answer}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 13: Final Berry CTA */}
      <section className="bg-[#9E1B50] text-white py-16 md:py-24 w-full">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto text-left space-y-6">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/80 block">
            START ON PAGE ONE
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-normal text-white max-w-4xl leading-[1.1]">
            You cannot change what you have not named.
          </h2>
          <p className="text-sm md:text-base text-white/90 font-light leading-relaxed max-w-2xl">
            Find the source. Tell the truth. Write your becoming down where you
            cannot unsee it.
          </p>

          <div className="flex flex-wrap gap-4 pt-4">
            <a
              href="https://store.iamieshiadanielle.com/product-details/product/from-burnout-to-becoming-purpose-workbook-for-moms"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white hover:bg-[#FAF6F0] text-[#4A0E26] font-bold uppercase text-[11px] tracking-wider px-8 py-4 rounded-xl transition-all"
            >
              GET THE WORKBOOK →
            </a>
            <a
              href="https://quiz.iamieshiadanielle.com/quiz"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-transparent border border-white text-white hover:bg-white hover:text-[#4A0E26] font-bold uppercase text-[11px] tracking-wider px-8 py-4 rounded-xl transition-all"
            >
              TAKE THE QUIZ FIRST →
            </a>
          </div>
        </div>
      </section>
    </>
  );
};
